<template>
    <div>
        <SbInputGroup class="mb-3">
            <SbInputGroupPrepend>
                <SbInputGroupText>Filtrera* <i class="fal fa-search ml-2"></i></SbInputGroupText>
            </SbInputGroupPrepend>

            <SbFormInput v-model="filterText" type="text"></SbFormInput>
        </SbInputGroup>

        <SbTable :items="items" :fields="fields" :primary-key="primaryKey" :sort-by="sortBy" :sort-desc="sortDesc" :filter="filterText" :filter-included-fields="filterIncludedFields">
            <template #cell(client_company)="data">
                <small v-if="data.value === 'Privatkund'" style="opacity:0.5">
                    <i class="fal fa-user-alt mr-1"></i> {{data.value}}
                </small>
                <small v-else>
                    <i class="fal fa-industry-alt mr-1"></i> {{data.value}}
                </small>
            </template>

            <template #cell(statuses)="data">
                <a v-for="(statusItem, statusIdx) in data.value" :key="statusIdx" :href="statusItem.href" class="ml-1">
                    <SbBadge pill :variant="statusItem.type">
                        {{statusItem.title}}
                        <i v-if="statusItem.icon" :class="`fal fa-${statusItem.icon} ml-1`"></i>
                    </SbBadge>
                </a>
            </template>

            <template #cell(links)="data" class="text-right">
                <div class="text-right">
                    <a v-for="(linkItem, linkIndex) in data.value" :key="linkIndex" :href="linkItem.href" :title="linkItem.title" class="btn btn-default btn-sm">
                        <i v-if="linkItem.icon" :class="`fal fa-${linkItem.icon}`"></i>
                    </a>
                </div>
            </template>
        </SbTable>
        <div v-if="!isLoaded" class="text-center">
            <SbSpinner label="Laddar.."></SbSpinner>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script setup lang="ts">
import axios from "axios";
import { onMounted, ref } from "vue";
import SbBadge from "../sb/SbBadge.vue";
import SbFormInput from "../sb/SbFormInput.vue";
import SbInputGroup from "../sb/SbInputGroup.vue";
import SbInputGroupPrepend from "../sb/SbInputGroupPrepend.vue";
import SbInputGroupText from "../sb/SbInputGroupText.vue";
import SbSpinner from "../sb/SbSpinner.vue";
import SbTable from "../sb/SbTable.vue";

const primaryKey = "id";
const sortBy = ref("created_at");
const sortDesc = ref(true);
const filterIncludedFields = ["created_at", "customer_name", "client_company", "statuses"];
const filterText = ref("");
const fields = [
    { key: "created_at", label: "Skickad datum", sortable: true, formatter: (value: string) => value.substring(0, 10), filterByFormatted: true, sortByFormatted: true },
    { key: "customer_name", label: "Kund", sortable: true },
    { key: "client_company", label: "Typ", sortable: true, formatter: (value: string | null) => value || "Privatkund", filterByFormatted: true, sortByFormatted: true },
    { key: "statuses", label: "Status", sortable: true, sortByFormatted: (value: any[]) => value.length ? value[0].title : null, filterByFormatted: (value: any[]) => value.length ? value : null },
    { key: "links", label: "", sortable: false },
];
const items = ref<any[]>([]);
const isLoaded = ref(false);
onMounted(async () => {
    const response = await axios.get("/leads");
    items.value = response.data.data;
    isLoaded.value = true;
});
</script>
